import { render, staticRenderFns } from "./zuzhuang.vue?vue&type=template&id=51e21636&scoped=true&"
import script from "./zuzhuang.vue?vue&type=script&lang=js&"
export * from "./zuzhuang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e21636",
  null
  
)

export default component.exports